import React from 'react'

const SvgStore = props => (
  <svg id='store_svg__connect_5' x={0} y={0} viewBox='0 0 609 489' xmlSpace='preserve' {...props}>
    <style>
      {
        '.store_svg__st1{fill-rule:evenodd;clip-rule:evenodd}.store_svg__st1,.store_svg__st2{fill:#ff8a00}.store_svg__st3{font-family:&apos;SourceHanSansCN-Regular-GBpc-EUC-H&apos;}.store_svg__st4{font-size:12px}.store_svg__st5{fill-rule:evenodd;clip-rule:evenodd;fill:#fd5c1f}.store_svg__st6{fill:#fff;stroke:#999;stroke-dasharray:4,2}.store_svg__st7{fill:#fd5c1f}.store_svg__st8{fill:#fff}.store_svg__st9{font-size:11px}.store_svg__st11{font-size:9.994px}.store_svg__st13{fill:#333}.store_svg__st15{font-size:14px}.store_svg__st17{fill:#f4f8fa}'
      }
    </style>
    <path
      id='store_svg__\u5706\u89D2\u77E9\u5F62_4_\u62F7\u8D1D_2'
      d='M180.5 116.5h424c2.76 0 5 2.24 5 5v250c0 2.76-2.24 5-5 5h-424c-2.76 0-5-2.24-5-5v-250c0-2.76 2.24-5 5-5z'
      fill='#f4f8fa'
      stroke='#999'
      strokeDasharray='4,2'
    />
    <g id='store_svg__arrow5'>
      <path
        id='store_svg__\u5F62\u72B6_41_\u62F7\u8D1D_12'
        className='store_svg__st1'
        d='M393 396h4.01l-5 6.91-5-6.91H391v-13h-4l5-6.1 5 6.1h-4v13z'
      />
      <text
        id='store_svg__SD-WAN\u4E13\u7EBF'
        transform='translate(399.987 394.239)'
        className='store_svg__st2 store_svg__st3 store_svg__st4'
      >
        {'SD-WAN\u4E13\u7EBF'}
      </text>
      <path
        id='store_svg__\u5F62\u72B6_41_\u62F7\u8D1D_14_1_'
        className='store_svg__st1'
        d='M393 104h4.01l-5 6.91-5-6.91H391V91h-4l5-6.11 5 6.11h-4'
      />
      <path
        id='store_svg__\u5F62\u72B6_41_\u62F7\u8D1D_17'
        className='store_svg__st5'
        d='M393 300h4l-5 5.91-5-5.91h4V193h-4l5-6.11 5 6.11h-4v107z'
      />
      <path
        id='store_svg__\u5F62\u72B6_41_\u62F7\u8D1D_18'
        className='store_svg__st5'
        d='M248 247v5l-6-6 6-6v5h288v-5l6.01 6-6.01 6v-5H248z'
      />
      <text
        id='store_svg__SD-WAN\u4E13\u7EBF-2'
        transform='translate(399.987 102.239)'
        className='store_svg__st2 store_svg__st3 store_svg__st4'
      >
        {'SD-WAN\u4E13\u7EBF'}
      </text>
    </g>
    <path
      id='store_svg__\u5706\u89D2\u77E9\u5F62_4_\u62F7\u8D1D_4'
      className='store_svg__st6'
      d='M5.5 98.5h80c2.76 0 5 2.24 5 5v290c0 2.76-2.24 5-5 5h-80c-2.76 0-5-2.24-5-5v-290c0-2.76 2.24-5 5-5z'
    />
    <path
      id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_13'
      className='store_svg__st7'
      d='M20 127h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5H20c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
    />
    <path
      id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_18'
      className='store_svg__st7'
      d='M367.17 22h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5V27c0-2.76 2.24-5 5-5z'
    />
    <text
      id='store_svg__\u5206\u652F\u673A\u6784A'
      transform='matrix(1.0011 0 0 1 366.218 73.813)'
      className='store_svg__st8 store_svg__st3 store_svg__st9'
    >
      {'\u5206\u652F\u673A\u6784A'}
    </text>
    <path
      id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_19'
      className='store_svg__st7'
      d='M367.17 407h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
    />
    <text
      id='store_svg__\u5206\u652F\u673A\u6784B'
      transform='matrix(1.0011 0 0 1 365.932 457.813)'
      className='store_svg__st8 store_svg__st3'
      fontSize={11.424}
    >
      {'\u5206\u652F\u673A\u6784B'}
    </text>
    <text
      id='store_svg__\u6570\u636E\u5E93_\u62F7\u8D1D'
      transform='translate(27 178.795)'
      className='store_svg__st8 store_svg__st3 store_svg__st4'
    >
      {'\u6570\u636E\u5E93'}
    </text>
    <path
      id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_14'
      className='store_svg__st7'
      d='M20 215h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5H20c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
    />
    <text
      id='store_svg__\u670D\u52A1\u5668_\u62F7\u8D1D'
      transform='translate(27 265.795)'
      className='store_svg__st8 store_svg__st3 store_svg__st4'
    >
      {'\u670D\u52A1\u5668'}
    </text>
    <path
      id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_15'
      className='store_svg__st7'
      d='M20 302h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5H20c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
    />
    <text
      id='store_svg__\u4E2D\u95F4\u4EF6_\u62F7\u8D1D'
      transform='translate(27 355.795)'
      className='store_svg__st8 store_svg__st3 store_svg__st4'
    >
      {'\u4E2D\u95F4\u4EF6'}
    </text>
    <g id='store_svg__\u956D\u901F\u4E91'>
      <path
        id='store_svg__\u5706\u89D2\u77E9\u5F62_4_\u62F7\u8D1D'
        className='store_svg__st6'
        d='M267.5 201.5h250c2.76 0 5 2.24 5 5v80c0 2.76-2.24 5-5 5h-250c-2.76 0-5-2.24-5-5v-80c0-2.76 2.24-5 5-5z'
      />
      <g id='store_svg__\u7EC4_30'>
        <path
          id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_3'
          className='store_svg__st7'
          d='M284 215h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
        />
        <text
          id='store_svg__\u63A5\u5165\u70B9'
          transform='translate(293 268.881)'
          className='store_svg__st8 store_svg__st3 store_svg__st9'
        >
          {'\u63A5\u5165\u70B9'}
        </text>
      </g>
      <g id='store_svg__\u7EC4_29'>
        <path
          id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_4'
          className='store_svg__st7'
          d='M367 215h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
        />
        <text
          id='store_svg__POP\u8282\u70B9A'
          transform='translate(365.322 268.881)'
          className='store_svg__st8 store_svg__st3 store_svg__st9'
        >
          {'POP\u8282\u70B9A'}
        </text>
        <path
          id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_10'
          className='store_svg__st7'
          d='M444 215h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
        />
        <text
          id='store_svg__POP\u8282\u70B9B'
          transform='translate(444.022 268.881)'
          className='store_svg__st8 store_svg__st3 store_svg__st9'
        >
          {'POP\u8282\u70B9B'}
        </text>
      </g>
      <g id='store_svg__\u7EC4_28'>
        <path
          id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_9'
          className='store_svg__st7'
          d='M367 308h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
        />
        <text
          id='store_svg__\u4E92\u8054\u4E91\u8282\u70B9B'
          transform='translate(363.732 361.881)'
          className='store_svg__st8 store_svg__st3 store_svg__st11'
        >
          {'\u4E92\u8054\u4E91\u8282\u70B9B'}
        </text>
        <path
          id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_16'
          className='store_svg__st7'
          d='M367 123h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
        />
        <text
          id='store_svg__\u4E92\u8054\u4E91\u8282\u70B9A'
          transform='translate(363.982 176.88)'
          className='store_svg__st8 store_svg__st3'
          fontSize={10}
        >
          {'\u4E92\u8054\u4E91\u8282\u70B9A'}
        </text>
        <path
          id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_20'
          className='store_svg__st7'
          d='M548 216h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
        />
        <text
          id='store_svg__\u4E92\u8054\u4E91\u8282\u70B9C'
          transform='translate(544.827 269.881)'
          className='store_svg__st8 store_svg__st3 store_svg__st11'
        >
          {'\u4E92\u8054\u4E91\u8282\u70B9C'}
        </text>
        <path
          id='store_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_17'
          className='store_svg__st7'
          d='M185 216h50c2.76 0 5 2.24 5 5v50c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50c0-2.76 2.24-5 5-5z'
        />
        <text
          id='store_svg__\u4E91\u7F51\u5173'
          transform='translate(192.01 267.881)'
          className='store_svg__st8 store_svg__st3 store_svg__st9'
        >
          {'\u4E91\u7F51\u5173'}
        </text>
      </g>
      <text
        id='store_svg__\u956D\u901F\u4E91\u9AA8\u7F51'
        transform='translate(261.074 189.207)'
        className='store_svg__st13 store_svg__st15'
        fontFamily='SourceHanSansCN-Normal-GBpc-EUC-H'
      >
        {'\u956D\u901F\u4E91\u9AA8\u7F51'}
      </text>
      <text
        id='store_svg__\u96F6\u552EA'
        transform='translate(374 11.837)'
        className='store_svg__st13 store_svg__st3 store_svg__st15'
      >
        {'\u96F6\u552EA'}
      </text>
      <text
        id='store_svg__\u96F6\u552EB_'
        transform='translate(374 487)'
        className='store_svg__st13 store_svg__st3 store_svg__st15'
      >
        {'\u96F6\u552EB'}
      </text>
      <text
        id='store_svg__\u4F01\u4E1A\u603B\u90E8'
        transform='translate(0 87.909)'
        className='store_svg__st13 store_svg__st3 store_svg__st15'
      >
        {'\u4F01\u4E1A\u603B\u90E8'}
      </text>
    </g>
    <path
      id='store_svg__\u5F62\u72B6_41_\u62F7\u8D1D_13'
      className='store_svg__st5'
      d='M98 260v3.98l-6-5.01 6-5.01V258h68v-4l6.09 4.98L166 264v-4H98z'
    />
    <path
      id='store_svg__\u5F62\u72B6_41_\u62F7\u8D1D_20'
      className='store_svg__st1'
      d='M98 239v4l-6-5.02 6-5.01V237h68v-4l6.09 4.98L166 243v-4H98z'
    />
    <text
      id='store_svg__SD-WAN\u4E13\u7EBF-3'
      transform='translate(97.038 230.968)'
      className='store_svg__st2 store_svg__st3 store_svg__st4'
    >
      {'SD-WAN\u4E13\u7EBF'}
    </text>
    <text
      id='store_svg__MSTP_\u4E13\u7EBF'
      transform='translate(102.948 277)'
      className='store_svg__st3 store_svg__st4'
      fill='#666'
    >
      {'MSTP \u4E13\u7EBF'}
    </text>
    <path
      className='store_svg__st8'
      d='M47.42 327.8c-2.01 1.06-3.11 1.05-4.7.28-1.59-.77-14.76-6.38-14.76-6.38v4.06c0 .35.48.72 1.38 1.15 1.8.88 11.81 5 13.38 5.76 1.58.76 2.69.78 4.7-.28 2.01-1.05 11.4-5 13.22-5.95.92-.47 1.33-.89 1.33-1.22v-4.01c-.01.01-12.55 5.52-14.55 6.59zm0 0'
    />
    <path
      className='store_svg__st8'
      d='M47.49 333.8c-2.01 1.06-3.11 1.05-4.7.28-1.59-.77-14.76-6.38-14.76-6.38v4.06c0 .35.48.72 1.38 1.15 1.8.88 11.81 5 13.38 5.76 1.58.76 2.69.77 4.7-.28 2.01-1.05 11.4-5 13.22-5.95.92-.49 1.33-.87 1.33-1.21v-4.01s-12.55 5.51-14.55 6.58zm14.53-18.2c0-.34-.44-.64-1.35-.97-1.77-.64-11.11-4.31-12.92-4.95-1.81-.65-2.52-.62-4.62.12s-12.05 4.58-13.82 5.28c-.89.35-1.33.67-1.3 1.01v3.88s13.18 5.47 14.77 6.22c1.59.75 2.69.75 4.7-.27 2.01-1.02 14.54-6.48 14.54-6.48v-3.84zm-4.4.1l-5.17 2.01-4.65-1.82 5.15-2.02 4.67 1.83zm-9.54 1.93l-2.38 3.45-5.5-2.27 7.88-1.18zm-4.14-5.25l-.76-1.39 2.37.92 2.24-.73-.61 1.43 2.28.83-2.95.3-.65 1.58-1.06-1.75-3.4-.3 2.54-.89zm-5.86 1.95c2.33 0 4.21.72 4.21 1.61 0 .9-1.89 1.61-4.21 1.61s-4.21-.72-4.21-1.61c-.01-.89 1.88-1.61 4.21-1.61zm0 0M47.99 143.56v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.94.01-3.77-.25-5.23-.73zM45.95 136.23c.02 1.13 3.12 2.4 7.27 2.4 4.16 0 7.28-1.27 7.28-2.41 0-1.14-3.11-2.41-7.28-2.41-4.16 0-7.26 1.27-7.27 2.4v.02zM30.5 152.78v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.66-8.26-1.92z'
    />
    <path
      className='store_svg__st8'
      d='M30.5 147.75v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92-3.25-.01-6.64-.67-8.26-1.92zM47.99 148.26v3.68c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.06c-1.48 1.13-4.44 1.73-7.27 1.73-1.94 0-3.77-.25-5.23-.73z'
    />
    <path
      className='store_svg__st8'
      d='M30.5 142.71v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.66-8.26-1.92zM53.22 139.59c-2.84 0-5.79-.6-7.27-1.73v.88c1.25.58 2.04 1.35 2.04 2.3v1.49c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.06c-1.47 1.14-4.43 1.74-7.27 1.74zM47.99 152.96v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.94.01-3.77-.25-5.23-.73zM30.5 157.82v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.67-8.26-1.92z'
    />
    <path
      className='store_svg__st8'
      d='M38.76 138.43c-4.73 0-8.26 1.38-8.26 2.62 0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62c0-1.24-3.53-2.62-8.26-2.62z'
    />
    <g>
      <path
        className='store_svg__st8'
        d='M56.42 221.06H33.37c-1.88 0-3.38 1.48-3.38 3.25s1.51 3.25 3.38 3.25h23.05c1.84 0 3.38-1.45 3.38-3.25.01-1.8-1.53-3.25-3.38-3.25zm-13.52 4h-9v-2h9v2zm4.67.26c-.64 0-1.16-.49-1.16-1.11s.51-1.11 1.16-1.11c.64 0 1.16.49 1.16 1.11-.01.59-.52 1.11-1.16 1.11zm4.11 0c-.64 0-1.16-.49-1.16-1.11s.51-1.11 1.16-1.11c.64 0 1.16.49 1.16 1.11.03.59-.49 1.11-1.16 1.11zm3.98 0c-.64 0-1.16-.49-1.16-1.11s.51-1.11 1.16-1.11 1.16.49 1.16 1.11c.03.59-.51 1.11-1.16 1.11zM56.42 228.56H33.37c-1.84 0-3.38 1.45-3.38 3.25 0 1.77 1.51 3.25 3.38 3.25h23.05c1.84 0 3.38-1.45 3.38-3.25.01-1.8-1.53-3.25-3.38-3.25zm-13.52 4.5h-9v-2h9v2zm4.73.23c-.64 0-1.16-.49-1.16-1.11 0-.62.51-1.11 1.16-1.11.64 0 1.16.49 1.16 1.11.03.62-.52 1.11-1.16 1.11zm4.15 0c-.64 0-1.16-.49-1.16-1.11 0-.62.51-1.11 1.16-1.11.64 0 1.16.49 1.16 1.11s-.52 1.11-1.16 1.11zm3.98 0c-.64 0-1.16-.49-1.16-1.11 0-.62.51-1.11 1.16-1.11.64 0 1.16.49 1.16 1.11s-.52 1.11-1.16 1.11zM56.55 242.56c1.84 0 3.38-1.45 3.38-3.25 0-1.77-1.51-3.25-3.38-3.25H33.5c-1.84 0-3.38 1.45-3.38 3.25 0 1.77 1.51 3.25 3.38 3.25h10.9v3h-1.5v2h-12v2h12v1.5h5v-1.5h11v-2h-11v-2h-1.5v-3h10.15zm-.72-4.61c.64 0 1.16.49 1.16 1.11 0 .62-.51 1.11-1.16 1.11-.64 0-1.16-.49-1.16-1.11 0-.62.51-1.11 1.16-1.11zm-3.99 0c.64 0 1.16.49 1.16 1.11 0 .62-.51 1.11-1.16 1.11-.64 0-1.16-.49-1.16-1.11 0-.62.52-1.11 1.16-1.11zm-4.11 0c.64 0 1.16.49 1.16 1.11 0 .62-.51 1.11-1.16 1.11-.64 0-1.16-.49-1.16-1.11-.03-.62.48-1.11 1.16-1.11zm-4.83 2.11h-9v-2h9v2z'
      />
    </g>
    <g>
      <path
        className='store_svg__st8'
        d='M389.31 413.83h-9.27c-1.03 0-1.88.84-1.88 1.88v26.25c0 1.03.84 1.88 1.88 1.88h9.25c1.03 0 1.88-.84 1.88-1.88V415.7c0-.93-.93-1.87-1.86-1.87zm-4.76 22.38c-1.5 0-2.81-1.31-2.81-2.81s1.31-2.81 2.81-2.81 2.81 1.31 2.81 2.81-1.31 2.81-2.81 2.81zm4.62-11.38h-9v-2h9v2zm0-3h-9v-2h9v2zm15.14-8h-9.27c-1.03 0-1.87.84-1.87 1.87v26.25c0 1.03.84 1.88 1.88 1.88h9.25c1.03 0 1.88-.84 1.88-1.88V415.7c-.01-.93-.94-1.87-1.87-1.87zm-4.39 22.38c-1.5 0-2.81-1.31-2.81-2.81s1.31-2.81 2.81-2.81 2.81 1.31 2.81 2.81c.01 1.5-1.31 2.81-2.81 2.81zm5.25-11.38h-10v-2h10v2zm0-3h-10v-2h10v2z'
      />
    </g>
    <g>
      <path
        className='store_svg__st8'
        d='M389.31 29.05h-9.27c-1.03 0-1.88.84-1.88 1.88v26.25c0 1.03.84 1.88 1.88 1.88h9.25c1.03 0 1.88-.84 1.88-1.88V30.92c0-.93-.93-1.87-1.86-1.87zm-4.76 22.38c-1.5 0-2.81-1.31-2.81-2.81s1.31-2.81 2.81-2.81 2.81 1.31 2.81 2.81-1.31 2.81-2.81 2.81zm4.62-11.38h-9v-2h9v2zm0-3h-9v-2h9v2zm15.14-8h-9.27c-1.03 0-1.87.84-1.87 1.87v26.25c0 1.03.84 1.88 1.88 1.88h9.25c1.03 0 1.88-.84 1.88-1.88V30.92c-.01-.93-.94-1.87-1.87-1.87zm-4.39 22.38c-1.5 0-2.81-1.31-2.81-2.81s1.31-2.81 2.81-2.81 2.81 1.31 2.81 2.81c.01 1.5-1.31 2.81-2.81 2.81zm5.25-11.38h-10v-2h10v2zm0-3h-10v-2h10v2z'
      />
    </g>
    <path
      className='store_svg__st17'
      d='M396.9 222.71h-9.79c-.34 0-.62.28-.62.62v28.75c0 .34.28.62.62.62h9.79c.34 0 .62-.28.62-.62v-28.75c0-.34-.28-.62-.62-.62zm-4.9 24.52c-1.2 0-2.18-.98-2.18-2.18s.98-2.18 2.18-2.18c1.2 0 2.18.98 2.18 2.18s-.98 2.18-2.18 2.18zm4.01-11.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .35-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm15.25-.72c0-.29-.25-.55-.55-.58-2.9-.26-5.81-.53-8.71-.79-.03 0-.12 0-.22.03l-3.39.86v26.67l3.51.5c.04.01.1 0 .1 0 2.9-.26 5.81-.56 8.71-.82.31-.03.55-.29.55-.58v-25.29zm-8.48 1.83c0-.32.25-.55.55-.53l6.02.42c.31.02.55.28.55.58v.54c0 .3-.25.52-.55.51-2.01-.11-4.01-.23-6.02-.34a.6.6 0 01-.55-.6v-.58zm7.13 9.09c0 .3-.25.54-.55.54l-6.02.06a.55.55 0 01-.55-.56v-.57c0-.32.25-.57.55-.57 2.01.01 4.01.01 6.02.02.31 0 .55.24.55.54v.54zm-.56-2.16c-2.01-.02-4.01-.05-6.02-.07-.31 0-.55-.26-.55-.58v-.57c0-.32.25-.56.55-.56l6.02.15c.31.01.55.26.55.55v.54c.01.3-.24.54-.55.54zm.56-3.23c0 .3-.25.53-.55.52l-6.02-.21a.577.577 0 01-.55-.59v-.57c0-.32.25-.56.55-.54 2.01.1 4.01.19 6.02.29.31.01.55.27.55.57v.53zm-27.9-6.9l-8.71.79c-.31.03-.55.29-.55.58v25.27c0 .29.25.55.55.58 2.9.26 5.81.56 8.71.82 0 0 .06.01.1 0l3.51-.5v-26.67l-3.39-.86c-.1-.01-.19-.02-.22-.01zm-.79 12.33c0 .32-.25.57-.55.56l-6.02-.07c-.31 0-.55-.25-.55-.54v-.54c0-.3.25-.54.55-.54 2.01 0 4.01-.01 6.02-.02.31 0 .55.25.55.57v.58zm0-2.85c0 .32-.25.57-.55.58-2.01.02-4.01.05-6.02.07-.31 0-.55-.23-.55-.53v-.54c0-.3.25-.55.55-.55l6.02-.15c.31-.01.55.24.55.56v.56zm0-2.86c0 .32-.25.58-.55.59l-6.02.21a.518.518 0 01-.55-.52v-.54c0-.3.25-.55.55-.57 2.01-.1 4.01-.19 6.02-.29.31-.01.55.23.55.54v.58zm0-2.85a.6.6 0 01-.55.6c-2.01.11-4.01.23-6.02.34a.505.505 0 01-.55-.51v-.54c0-.3.25-.56.55-.58l6.02-.42c.31-.02.55.22.55.53v.58zm0 0M315.71 222.71h-9.79c-.34 0-.62.28-.62.62v28.75c0 .34.28.62.62.62h9.79c.34 0 .62-.28.62-.62v-28.75c0-.34-.28-.62-.62-.62zm-4.9 24.52c-1.2 0-2.18-.98-2.18-2.18s.98-2.18 2.18-2.18c1.2 0 2.18.98 2.18 2.18s-.97 2.18-2.18 2.18zm4.01-11.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .35-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm15.25-.72c0-.29-.25-.55-.55-.58-2.9-.26-5.81-.53-8.71-.79-.03 0-.12 0-.22.03l-3.39.86v26.67l3.51.5c.04.01.1 0 .1 0 2.9-.26 5.81-.56 8.71-.82.31-.03.55-.29.55-.58v-25.29zm-8.47 1.83c0-.32.25-.55.55-.53l6.02.42c.31.02.55.28.55.58v.54c0 .3-.25.52-.55.51-2.01-.11-4.01-.23-6.02-.34a.6.6 0 01-.55-.6v-.58zm7.12 9.09c0 .3-.25.54-.55.54l-6.02.06a.55.55 0 01-.55-.56v-.57c0-.32.25-.57.55-.57 2.01.01 4.01.01 6.02.02.31 0 .55.24.55.54v.54zm-.55-2.16c-2.01-.02-4.01-.05-6.02-.07-.31 0-.55-.26-.55-.58v-.57c0-.32.25-.56.55-.56l6.02.15c.31.01.55.26.55.55v.54c0 .3-.24.54-.55.54zm.55-3.23c0 .3-.25.53-.55.52l-6.02-.21a.577.577 0 01-.55-.59v-.57c0-.32.25-.56.55-.54 2.01.1 4.01.19 6.02.29.31.01.55.27.55.57v.53zm-27.9-6.9l-8.71.79c-.31.03-.55.29-.55.58v25.27c0 .29.25.55.55.58 2.9.26 5.81.56 8.71.82 0 0 .06.01.1 0l3.51-.5v-26.67l-3.39-.86a.889.889 0 00-.22-.01zm-.79 12.33c0 .32-.25.57-.55.56l-6.02-.07c-.31 0-.55-.25-.55-.54v-.54c0-.3.25-.54.55-.54 2.01 0 4.01-.01 6.02-.02.31 0 .55.25.55.57v.58zm0-2.85c0 .32-.25.57-.55.58-2.01.02-4.01.05-6.02.07-.31 0-.55-.23-.55-.53v-.54c0-.3.25-.55.55-.55l6.02-.15c.31-.01.55.24.55.56v.56zm0-2.86c0 .32-.25.58-.55.59l-6.02.21a.518.518 0 01-.55-.52v-.54c0-.3.25-.55.55-.57 2.01-.1 4.01-.19 6.02-.29.31-.01.55.23.55.54v.58zm0-2.85a.6.6 0 01-.55.6c-2.01.11-4.01.23-6.02.34a.505.505 0 01-.55-.51v-.54c0-.3.25-.56.55-.58l6.02-.42c.31-.02.55.22.55.53v.58zm0 0M475.27 222.71h-9.79c-.34 0-.62.28-.62.62v28.75c0 .34.28.62.62.62h9.79c.34 0 .62-.28.62-.62v-28.75c0-.34-.28-.62-.62-.62zm-4.9 24.52c-1.2 0-2.18-.98-2.18-2.18s.98-2.18 2.18-2.18c1.2 0 2.18.98 2.18 2.18s-.98 2.18-2.18 2.18zm4.01-11.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .35-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm15.25-.72c0-.29-.25-.55-.55-.58-2.9-.26-5.81-.53-8.71-.79-.03 0-.12 0-.22.03l-3.39.86v26.67l3.51.5c.04.01.1 0 .1 0 2.9-.26 5.81-.56 8.71-.82.31-.03.55-.29.55-.58v-25.29zm-8.48 1.83c0-.32.25-.55.55-.53l6.02.42c.31.02.55.28.55.58v.54c0 .3-.25.52-.55.51-2.01-.11-4.01-.23-6.02-.34a.6.6 0 01-.55-.6v-.58zm7.13 9.09c0 .3-.25.54-.55.54l-6.02.06a.55.55 0 01-.55-.56v-.57c0-.32.25-.57.55-.57 2.01.01 4.01.01 6.02.02.31 0 .55.24.55.54v.54zm-.55-2.16c-2.01-.02-4.01-.05-6.02-.07-.31 0-.55-.26-.55-.58v-.57c0-.32.25-.56.55-.56l6.02.15c.31.01.55.26.55.55v.54c0 .3-.25.54-.55.54zm.55-3.23c0 .3-.25.53-.55.52l-6.02-.21a.577.577 0 01-.55-.59v-.57c0-.32.25-.56.55-.54 2.01.1 4.01.19 6.02.29.31.01.55.27.55.57v.53zm-27.9-6.9l-8.71.79c-.31.03-.55.29-.55.58v25.27c0 .29.25.55.55.58 2.9.26 5.81.56 8.71.82 0 0 .06.01.1 0l3.51-.5v-26.67l-3.39-.86c-.1-.01-.19-.02-.22-.01zm-.79 12.33c0 .32-.25.57-.55.56l-6.02-.07c-.31 0-.55-.25-.55-.54v-.54c0-.3.25-.54.55-.54 2.01 0 4.01-.01 6.02-.02.31 0 .55.25.55.57v.58zm0-2.85c0 .32-.25.57-.55.58-2.01.02-4.01.05-6.02.07-.31 0-.55-.23-.55-.53v-.54c0-.3.25-.55.55-.55l6.02-.15c.31-.01.55.24.55.56v.56zm0-2.86c0 .32-.25.58-.55.59l-6.02.21a.518.518 0 01-.55-.52v-.54c0-.3.25-.55.55-.57 2.01-.1 4.01-.19 6.02-.29.31-.01.55.23.55.54v.58zm0-2.85a.6.6 0 01-.55.6c-2.01.11-4.01.23-6.02.34a.505.505 0 01-.55-.51v-.54c0-.3.25-.56.55-.58l6.02-.42c.31-.02.55.22.55.53v.58zm0 0'
    />
    <path
      className='store_svg__st8'
      d='M204.87 248.64h-10.7v-4.42h8.32l1.83-2.38 2.99 3.65-2.44 3.15zm-2.66-13.29h-3.23v3.61l-6.3-5.82 6.3-5.82v3.61h5.61l10.22 13.29h8.32v4.42h-10.7l-10.22-13.29zm16.11 3.61v-3.61h-3.23l-2.38 3.1c-.9-1.18-1.97-2.57-2.88-3.77l2.88-3.75h5.61v-3.61l6.3 5.82-6.3 5.82zm0 0'
    />
    <g>
      <path
        id='store_svg__Combined-Shape_38_'
        className='store_svg__st8'
        d='M589.5 251.44h-2v-23h-29v21h31v2h-33v-25h33z'
      />
      <path id='store_svg__Rectangle-17_3_' className='store_svg__st8' d='M566.5 254.44h13v2h-13z' />
      <path id='store_svg__Rectangle-73_3_' className='store_svg__st8' d='M572.5 250.44h2v6h-2z' />
      <path id='store_svg__Rectangle-Copy-2_1_' className='store_svg__st8' d='M562.5 232.44h7v2h-7z' />
      <path id='store_svg__Rectangle-Copy-3_1_' className='store_svg__st8' d='M562.5 237.44h13v2h-13z' />
      <path id='store_svg__Rectangle-Copy-4_1_' className='store_svg__st8' d='M562.5 242.44h20v2h-20z' />
    </g>
    <g>
      <path
        id='store_svg__Combined-Shape_1_'
        className='store_svg__st8'
        d='M407.67 157.22h-2v-23h-29v21h31v2h-33v-25h33z'
      />
      <path id='store_svg__Rectangle-17_1_' className='store_svg__st8' d='M384.67 160.22h13v2h-13z' />
      <path id='store_svg__Rectangle-73_1_' className='store_svg__st8' d='M390.67 156.22h2v6h-2z' />
      <path id='store_svg__Rectangle-Copy-2_2_' className='store_svg__st8' d='M380.67 138.22h7v2h-7z' />
      <path id='store_svg__Rectangle-Copy-3_2_' className='store_svg__st8' d='M380.67 143.22h13v2h-13z' />
      <path id='store_svg__Rectangle-Copy-4_2_' className='store_svg__st8' d='M380.67 148.22h20v2h-20z' />
    </g>
    <g>
      <path
        id='store_svg__Combined-Shape_2_'
        className='store_svg__st8'
        d='M407.67 339.86h-2v-23h-29v21h31v2h-33v-25h33z'
      />
      <path id='store_svg__Rectangle-17_2_' className='store_svg__st8' d='M384.67 342.86h13v2h-13z' />
      <path id='store_svg__Rectangle-73_2_' className='store_svg__st8' d='M390.67 338.86h2v6h-2z' />
      <path id='store_svg__Rectangle-Copy-2_3_' className='store_svg__st8' d='M380.67 320.86h7v2h-7z' />
      <path id='store_svg__Rectangle-Copy-3_3_' className='store_svg__st8' d='M380.67 325.86h13v2h-13z' />
      <path id='store_svg__Rectangle-Copy-4_3_' className='store_svg__st8' d='M380.67 330.86h20v2h-20z' />
    </g>
  </svg>
)

export default SvgStore
